import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import appConf from '../../../conf/appConf'
import {
  fetchUser,
  fetchActivities,
  fetchRankingsStats,
  fetchSaleStats,
  fetchOrderCategoryDistribution,
  fetchPaginationBestsellers,
  fetchPageViews,
  fetchServiceDesks,
  fetchShortcuts,
  fetchShortcutSettings,
  updateShortcutSettings,
  fetchPromotions,
  fetchWarehouseOverview,
  fetchBrandDistribution,
  fetchBrandDistributionByBrandId,
  updateSaleStatSettings,
  fetchSalesPerformances,
  fetchSearchKeywords,
  fetchListingPageViews,
  fetchReturns,
  fetchReturnReasonSummaries,
  fetchSpecificReturnReasonsListings,
  fetchSpecificSearchKeywordListings,
  fetchAbandonedCarts,
  fetchArrivalNoticeSummaries,
  fetchListingTags,
  fetchSaleStatsByDate,
  fetchListings,
  fetchTrackListings,
  createTrackListings,
  updateTrackListings,
  fetchProductBundles,
  createSupplierCoupons,
  fetchMemberAnalyses
} from '../../app/actions'
import {
  setI13nData,
  setAlerts,
  createAlert,
  dismissAlert,
  dismissLastAlert,
  setToast,
  switchToast
} from '../../app/actions/common'
import SecretDashboard from '../components/Dashboard/SecretDashboard'

const mapStateToProps = (state, ownProps) => {
  return {
    i13nData: state.page.i13nData,
    supplier: state.supplier,
    page: state.page,
    flags: state.flags
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = Object.assign({
    setI13nData,
    setAlerts,
    createAlert,
    dismissAlert,
    dismissLastAlert,
    setToast,
    switchToast
  }, {
    fetchActivities,
    fetchRankingsStats,
    fetchSaleStats,
    fetchOrderCategoryDistribution,
    fetchPaginationBestsellers,
    fetchPageViews,
    fetchServiceDesks,
    fetchShortcuts,
    fetchShortcutSettings,
    updateShortcutSettings,
    fetchPromotions,
    fetchWarehouseOverview,
    fetchBrandDistribution,
    fetchBrandDistributionByBrandId,
    updateSaleStatSettings,
    fetchSalesPerformances,
    fetchSearchKeywords,
    fetchListingPageViews,
    fetchReturns,
    fetchReturnReasonSummaries,
    fetchSpecificReturnReasonsListings,
    fetchSpecificSearchKeywordListings,
    fetchAbandonedCarts,
    fetchArrivalNoticeSummaries,
    fetchListingTags,
    fetchSaleStatsByDate,
    fetchListings,
    fetchTrackListings,
    createTrackListings,
    updateTrackListings,
    fetchProductBundles,
    createSupplierCoupons,
    fetchMemberAnalyses
  })

  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

// Overrides default preFetcher in app.server.js
SecretDashboard.preFetcher = ({ store, req, res }) => {
  // Checking cookie sdb for verifying its existance, redirect to error page if not
  const cookies = req.cookies
  const sdbCookie = _.get(cookies, appConf.secretDashboardCookieKey, null)
  if (_.isEmpty(sdbCookie)) {
    // By falling into app.server.js to catch error object thus redirect to error page with code
    // returning 40100006 cookie has expired
    const error = { code: 40100006, message: 'Cookie失效，請重新登入', debug: `Missing cookie ${appConf.secretDashboardCookieKey}` }
    return Promise.reject(error)
  }

  // fetch user profile
  return Promise.resolve(store.dispatch(fetchUser()))
}

SecretDashboard.fetchData = ({ store, req, res }) => {
  const tasks = [
  ]
  return Promise.all(tasks)
}

const MappedDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(SecretDashboard)

export default MappedDashboard
